import { useTranslation } from 'react-i18next';

import { Card, Icon, Illustration, type IllustrationName, Title } from '~/components';

import {
  cardStyle,
  featureCategoriesStyle,
  featureCategoryStyle,
  featureCategoryTitleStyle,
  featureCheckIconStyle,
  featuresStyle,
  featureStyle,
  illustrationStyle,
  illustrationWrapperStyle,
  wrapperStyle,
} from './PricingFeatures.css';

export const PricingFeatures = () => {
  const { t } = useTranslation(['pricing']);

  return (
    <section className={wrapperStyle}>
      <Title as="h2">{t('pricing:pricingFeatures.title')}</Title>

      <div className={featureCategoriesStyle}>
        <PricingFeature
          features={[
            t('pricing:pricingFeatures.group1.feature1.label'),
            t('pricing:pricingFeatures.group1.feature2.label'),
            t('pricing:pricingFeatures.group1.feature3.label'),
            t('pricing:pricingFeatures.group1.feature4.label'),
          ]}
          illustration="Platform"
          title={t('pricing:pricingFeatures.group1.title')}
        />

        <PricingFeature
          features={[
            t('pricing:pricingFeatures.group2.feature1.label'),
            t('pricing:pricingFeatures.group2.feature2.label'),
            t('pricing:pricingFeatures.group2.feature3.label'),
            t('pricing:pricingFeatures.group2.feature4.label'),
          ]}
          illustration="Law"
          title={t('pricing:pricingFeatures.group2.title')}
        />

        <PricingFeature
          features={[
            t('pricing:pricingFeatures.group3.feature1.label'),
            t('pricing:pricingFeatures.group3.feature2.label'),
            t('pricing:pricingFeatures.group3.feature3.label'),
            t('pricing:pricingFeatures.group3.feature4.label'),
          ]}
          illustration="HandsShaking"
          title={t('pricing:pricingFeatures.group3.title')}
        />
      </div>
    </section>
  );
};

type Props = {
  features: string[];
  illustration: IllustrationName;
  illustrationStrokeWidth?: number;
  title: string;
};

const PricingFeature = ({ features, illustration, illustrationStrokeWidth = 1.4, title }: Props) => {
  return (
    <Card.Root className={cardStyle} key={title} variant="primary-light">
      <article className={featureCategoryStyle}>
        <div className={illustrationWrapperStyle}>
          <Illustration aria-hidden className={illustrationStyle} name={illustration} strokeWidth={illustrationStrokeWidth} />
        </div>

        <Title as="h3" className={featureCategoryTitleStyle} styleAs="h2">
          {title}
        </Title>

        <ul className={featuresStyle}>
          {features.map((feature) => (
            <li className={featureStyle} key={feature}>
              <Icon className={featureCheckIconStyle} name="Check" />
              {feature}
            </li>
          ))}
        </ul>
      </article>
    </Card.Root>
  );
};
